import SvgIcon from './SvgIcon.vue'

export default SvgIcon



// WEBPACK FOOTER //
// ./src/app/components/common/svgIcon/index.js